import { render } from "./DeliverInfo.vue?vue&type=template&id=38b1900a&scoped=true&ts=true"
import script from "./DeliverInfo.vue?vue&type=script&lang=ts"
export * from "./DeliverInfo.vue?vue&type=script&lang=ts"

import "./DeliverInfo.vue?vue&type=style&index=0&id=38b1900a&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b1900a"]])

export default __exports__